module.exports = __webpack_public_path__ + "img/122.did_not_find.51c74636.svg";